module.exports = __webpack_public_path__ + "static/media/LAUNDRY-LOGO.426eda3b.png";